import { Box, Divider, FlexBox } from '@dixa/lib-shared-habla';

import { ArticleSuggestion } from '../../types';
import { ArticleRow } from '../ArticleRow';
import { ArticleRowProps } from '../ArticleRow/ArticleRow';

import styles from './SuggestionList.module.scss';

type ArticleSuggestionListProps = {
  suggestions: ArticleSuggestion[];
  beforeSlot: React.ReactNode;
} & Omit<ArticleRowProps, 'article' | 'isSelected'>;
export function ArticleSuggestionList({
  suggestions,
  selectedArticleId,
  onSelectArticle,
  beforeSlot,
}: ArticleSuggestionListProps): JSX.Element {
  return (
    <FlexBox className={styles.ul} as="ul" gap="300" flexDirection="column">
      {beforeSlot}
      {suggestions.map((suggestion, index) => (
        <Box as="li" key={suggestion.id}>
          <ArticleRow
            article={suggestion}
            selectedArticleId={selectedArticleId}
            onSelectArticle={onSelectArticle}
          />
          {index + 1 < suggestions.length && (
            <Divider className={styles.divider} />
          )}
        </Box>
      ))}
    </FlexBox>
  );
}
